import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  Avatar,
  Dialog,
  DialogContent,
} from "@mui/material";
import {
  useDeleteDriverMutation,
  useGetDriverQuery,
} from "../../../Api/attoDeskApi";
import { IDriverLicense } from "../../../Api/Interface/api.interface";
import NewPopUpTeam from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import * as XLSX from "xlsx";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs, { Dayjs } from "dayjs";
import { Link } from "react-router-dom";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import CloseIcon from "@mui/icons-material/Close";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const [selectedCoursing, setSelectedCoursing] =
    useState<IDriverLicense | null>(null);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<IDriverLicense | null>(null);
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );

  const [open, setOpen] = useState(false);
  const [selectedEmpImg, setSelectedEmpImg] = useState<string>("");

  const { data, isLoading, isError, refetch } = useGetDriverQuery({
    searchText: currentSearchQuery,
    id: "",
  });

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IDriverLicense) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IDriverLicense) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const handleOpen = (imgUrl: string) => {
    setSelectedEmpImg(imgUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedEmpImg("");
    setOpen(false);
  };

  const [deleteCategory] = useDeleteDriverMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IDriverLicense[] = Array.isArray(data?.data)
    ? (data?.data as IDriverLicense[])
    : [];

  const handleAddProductClick = () => {
    navigate("/driver/licence/create");
  };

  const handleExportToExcel = () => {
    const exportData = coursings.map((row, index) => ({
      "#": index + 1,
      Name:
        capitalizeFirstLetter(row.first_name || "") +
          " " +
          capitalizeFirstLetter(row.last_name || "") || "",
      "License Number": row.license_number || "",
      Address: row.address || "",
      Sex: row.sex || "",
      DOB: row.date_of_birth || "",
      "Issue Date": row.issue_date || "",
      "Expiry Date": row.expiry_date || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "StaffDetails");
    const currentMonth = dayjs().format("YYYY MMM, DD");

    const fileName = `StafList_${currentMonth}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const tableData = coursings.map((row, index) => [
      index + 1,
      capitalizeFirstLetter(row.first_name || "") +
        " " +
        capitalizeFirstLetter(row.last_name || "") || "",
      row.license_number || "",
      row.address || "",
      row.sex || "",
      row.date_of_birth || "",
      row.issue_date || "",
      row.expiry_date || "",
    ]);

    const tableHeaders = [
      [
        "#",
        "Name",
        "License Number",
        "Address",
        "Sex",
        "DOB",
        "Issue Date",
        "Expiry Date",
      ],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Staf List`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`${currentMonth}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `StafList_${currentMonth}.pdf`;

      doc.save(fileName);
    };
  };

  return (
    <>
      {isMobileRes ? (
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={2}
            sx={{ borderBottom: 2, padding: 1 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "flex-start",
                  md: "flex-end",
                },
              }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "flex-start",
                    md: "flex-end",
                  },
                }}
              >
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CiSearch className={classes.searchWidgetIcon} />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.formControlList,
                      },
                    }}
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Name && Address .."
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "flex-start",
                  md: "flex-end",
                },
              }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "flex-end",
                  },
                }}
              >
                <Grid item>
                  <Button
                    startIcon={<TableViewIcon />}
                    className={classes.addButtonPdfExcel}
                    onClick={handleExportToExcel}
                  >
                    Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<LocalPrintshopSharpIcon />}
                    className={classes.addButtonPdfExcel}
                    onClick={handleExportToPDF}
                  >
                    pdf
                  </Button>
                </Grid>

                <Grid item>
                  <Link
                    to={`/driver/licence/create`}
                    className={classes.iconLinkPropNormal}
                  >
                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={handleAddProductClick}
                    >
                      Add New
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheader}>
                      <strong>License Number</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Name</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Address</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Actions</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isError || coursings.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        {isError ? "Error fetching data" : "No data available"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    coursings
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row: IDriverLicense, index) => (
                        <TableRow
                          key={row.id}
                          className={classes.tableRowHover}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {" "}
                            <Grid container spacing={1}>
                              <Grid item>
                                <Link
                                  to={`/driver-history/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Typography className={classes.nameTableList}>
                                    {row.license_number || ""}
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {" "}
                            <Grid container spacing={1}>
                              <Grid item>
                                <Link
                                  to={`/driver-history/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Typography className={classes.nameTableList}>
                                    {capitalizeFirstLetter(
                                      row.first_name || ""
                                    ) +
                                      " " +
                                      capitalizeFirstLetter(
                                        row.last_name || ""
                                      )}
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {row.address || ""}
                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid
                              container
                              spacing={1}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Grid item>
                                <Link
                                  to={`/driver-history/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Button
                                    // variant="contained"
                                    className={classes.viewButtonList}
                                    onClick={() =>
                                      navigate(`/driver-history/${row.id}`)
                                    }
                                  >
                                    <VisibilitySharpIcon
                                      className={classes.viewListIcon}
                                    />
                                  </Button>
                                </Link>
                              </Grid>
                              <Grid item>
                                <Button
                                  // variant="contained"
                                  className={classes.editButtonList}
                                  onClick={() => handleOpenDialog(row)}
                                >
                                  <EditSharpIcon
                                    className={classes.editListIcon}
                                  />
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  // variant="contained"
                                  className={classes.deleteButtonList}
                                  onClick={() => handleOpenDeletePopup(row)}
                                >
                                  <DeleteOutlineSharpIcon
                                    className={classes.deleteListIcon}
                                  />
                                </Button>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
              {/* <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid> */}
            </TableContainer>
            {selectedCoursing && (
              <NewPopUpTeam
                openModel={openDialog}
                handleCloseDialog={handleCloseDialog}
                data={selectedCoursing}
              />
            )}
            {coursingToDelete && (
              <DeletePopup
                open={openDeleteCategory}
                handleCloseDelete={handleCloseDeletePopup}
                onConfirm={async () => {
                  await handleDelete(coursingToDelete.id.toString());
                }}
                title="Delete Driver"
                content={`Are you sure you want to delete "${
                  coursingToDelete.first_name + " " + coursingToDelete.last_name
                }"?`}
              />
            )}
          </Grid>
        </Card>
      ) : (
        <Card className={classes.card}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            {/* <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Button
            variant="contained"
            className={classes.addNewButton}
            onClick={handleAddProductClick}
          >
            Add New
          </Button>
        </Grid> */}
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "flex-start",
                  md: "flex-end",
                },
              }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "flex-start",
                    md: "flex-end",
                  },
                }}
              >
                <Grid item>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CiSearch className={classes.searchWidgetIcon} />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.formControlList,
                      },
                    }}
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Name && Address .."
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>

                <Grid item>
                  <Button
                    startIcon={<TableViewIcon />}
                    className={classes.addButtonPdfExcel}
                    onClick={handleExportToExcel}
                  >
                    Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<LocalPrintshopSharpIcon />}
                    className={classes.addButtonPdfExcel}
                    onClick={handleExportToPDF}
                  >
                    pdf
                  </Button>
                </Grid>

                <Grid item>
                  <Link
                    to={`/driver/licence/create`}
                    className={classes.iconLinkPropNormal}
                  >
                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={handleAddProductClick}
                    >
                      Add New
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead className={classes.tableHeaderRow}>
                  <TableRow>
                    <TableCell className={classes.tablheaderId}>
                      <strong>#</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Name</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>License Number</strong>
                    </TableCell>
                    <TableCell className={classes.tablheader}>
                      <strong>Address</strong>
                    </TableCell>
                    <TableCell
                      className={classes.tablheader}
                      sx={{ textAlign: "right" }}
                    >
                      <strong>Actions</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isError || coursings.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={20} align="center">
                        {isError ? "Error fetching data" : "No data available"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    coursings
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row: IDriverLicense, index) => (
                        <TableRow
                          key={row.id}
                          className={classes.tableRowHover}
                        >
                          <TableCell scope="row" className={classes.tablCellId}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>

                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {" "}
                            <Grid container spacing={1}>
                              <Grid item>
                                <Box
                                  className={
                                    classes.SelectImageTableBoxBorder23
                                  }
                                  sx={{ cursor: "pointer" }}
                                >
                                  {row.license_img ? (
                                    <img
                                      src={row.license_img}
                                      alt="Img"
                                      className={classes.SelectImageTable3d}
                                      onClick={() =>
                                        handleOpen(row.license_img)
                                      }
                                    />
                                  ) : (
                                    <Avatar
                                      alt="Img"
                                      // src={AvatarImg}
                                      className={classes.SelectImageTable3d}
                                    ></Avatar>
                                  )}
                                </Box>
                              </Grid>
                              <Grid
                                item
                                textAlign={"center"}
                                alignContent={"center"}
                              >
                                <Link
                                  to={`/driver-history/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Typography className={classes.nameTableList}>
                                    {capitalizeFirstLetter(
                                      row.first_name || ""
                                    ) +
                                      " " +
                                      capitalizeFirstLetter(
                                        row.last_name || ""
                                      )}
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                          >
                            {" "}
                            <Grid container spacing={1}>
                              <Grid item>
                                <Link
                                  to={`/driver-history/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Typography className={classes.nameTableList}>
                                    {row.license_number || ""}
                                  </Typography>
                                </Link>
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell
                            scope="row"
                            className={classes.tablCell}
                            // sx={{ textAlign: "center" }}
                          >
                            {row.address || ""}
                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid
                              container
                              spacing={1}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Grid item>
                                <Link
                                  to={`/driver-history/${row.id}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <Button
                                    // variant="contained"
                                    className={classes.viewButtonList}
                                    onClick={() =>
                                      navigate(`/driver-history/${row.id}`)
                                    }
                                  >
                                    <VisibilitySharpIcon
                                      className={classes.viewListIcon}
                                    />
                                  </Button>
                                </Link>
                              </Grid>
                              <Grid item>
                                <Button
                                  // variant="contained"
                                  className={classes.editButtonList}
                                  onClick={() => handleOpenDialog(row)}
                                >
                                  <EditSharpIcon
                                    className={classes.editListIcon}
                                  />
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  // variant="contained"
                                  className={classes.deleteButtonList}
                                  onClick={() => handleOpenDeletePopup(row)}
                                >
                                  <DeleteOutlineSharpIcon
                                    className={classes.deleteListIcon}
                                  />
                                </Button>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
              {/* <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid> */}
            </TableContainer>

            <Dialog open={open} onClose={handleClose} maxWidth="xs">
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                p={1}
              >
                <Button
                  variant="contained"
                  className={classes.editButton}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </Button>
              </Box>
              <DialogContent sx={{ textAlign: "center" }}>
                {selectedEmpImg ? (
                  <>
                    <img
                      src={selectedEmpImg}
                      alt="Img"
                      style={{
                        width: 400,
                        height: 300,
                        objectFit: "cover",
                        borderRadius: 8,
                      }}
                    />

                    <Box mt={2}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        component="a"
                        href={selectedEmpImg}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.addButton}
                        startIcon={<DownloadOutlinedIcon />}
                      >
                        Download
                      </Button>
                    </Box>
                  </>
                ) : (
                  <Typography>No image available</Typography>
                )}
              </DialogContent>
            </Dialog>
            {selectedCoursing && (
              <NewPopUpTeam
                openModel={openDialog}
                handleCloseDialog={handleCloseDialog}
                data={selectedCoursing}
              />
            )}
            {coursingToDelete && (
              <DeletePopup
                open={openDeleteCategory}
                handleCloseDelete={handleCloseDeletePopup}
                onConfirm={async () => {
                  await handleDelete(coursingToDelete.id.toString());
                }}
                title="Delete Driver"
                content={`Are you sure you want to delete "${
                  coursingToDelete.first_name + " " + coursingToDelete.last_name
                }"?`}
              />
            )}
          </Grid>
        </Card>
      )}
    </>
  );
};

export default Index;
